<template>
  <div class="profile-page">
    <section class="section-profile-cover section-shaped my-0">
      <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </section>
    <section class="section section-skew">
      <div class="container">
        <card class="card-profile mt--300" no-body shadow>
          <div class="px-4">
            <div class="text-center mt-5">
              <h3>پیام ناشناس</h3>
              <div class="h6 font-weight-300"><i class="ni location_pin mr-2"></i>
                این امکان هنوز پیاده‌سازی نشده است
              </div>

              <base-button type="neutral" @click="goHome">برو به خانه</base-button>

              <div/>
              <br>

            </div>
          </div>
        </card>
      </div>
    </section>
  </div>
</template>

<script>
import Inputs from "./components/Inputs";

export default {
  components: {
    Inputs,
  },
  data() {
    return {}
  },
  methods: {
    goHome() {
      this.$router.push({name: 'home'})
    }
  }
};
</script>

<style scoped>

</style>
